import { ActionDelegate } from 'containers/Base/ActionDelegate';
import { UndefinedAble } from 'data/base';
import { Product } from 'data/terra/Product';
import { fetchProductsDelegate } from './actions/FetchProducts';
import { fetchMoreProductsDelegate } from './actions/FetchMoreProducts';
import { selectProductDelegate } from './actions/SelectProduct';
import { ProductSelectorAction } from './actionTypes';

export interface ProductSelectorState {
  products: Product[];
  hasInitialized: boolean;
  currentPage: number;
  isLoadingInit: boolean;
  hasMore: boolean;
  isLoadingMore: boolean;
  productError: UndefinedAble<string>;
  loadMoreError: UndefinedAble<string>;
  selectedProduct: UndefinedAble<Product>;
}

const initialState: ProductSelectorState = {
  products: [],
  hasInitialized: false,
  currentPage: 0,
  isLoadingInit: false,
  hasMore: true,
  isLoadingMore: false,
  productError: undefined,
  loadMoreError: undefined,
  selectedProduct: undefined,
};

const delegates: {
  [key: string]: ActionDelegate<any, ProductSelectorState>;
} = {
  ...fetchProductsDelegate,
  ...fetchMoreProductsDelegate,
  ...selectProductDelegate,
};

export default function reduce(
  state: ProductSelectorState = initialState,
  action: ProductSelectorAction
): ProductSelectorState {
  const delegate = delegates[action.type];
  if (delegate) {
    return delegate(state, action);
  } else {
    return state;
  }
}
